import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { RoleModel } from '../../../../services/RoleModel';
import { AraGenericChipComponent } from '@shared/ui/ara-generic-chip/ara-generic-chip.component';
import { AraButtonToggleGroupComponent } from '@shared/ui/ara-button-toggle-group/ara-button-toggle-group.component';
import { AraButtonToggleComponent } from '@shared/ui/ara-button-toggle-group/ara-button-toggle.component';
import { RolesDisplayService } from '../roles-display.service';
import { buildRoleHistoryByPerson, buildRoleHistoryByType, roleTrackKey } from '../roles-view-model';
import { AraButtonComponent } from '@shared/ui/ara-button/ara-button.component';

/**
 * Verlaufs-Ansicht der Rollen: umschaltbar zwischen rollenzentriert (Stafette je Rollentyp)
 * und personenzentriert. Rein präsentational; Klick auf einen Namen meldet `openPerson`.
 */
@Component({
	selector: 'ara-roles-history',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './roles-history.component.html',
	styleUrl: './roles-history.component.scss',
	imports: [AraButtonComponent, TranslocoDirective, AraButtonToggleGroupComponent, AraButtonToggleComponent, AraGenericChipComponent],
})
export class RolesHistoryComponent {
	protected readonly display = inject(RolesDisplayService);

	readonly roleModels = input<RoleModel[]>([]);
	readonly openPerson = output<RoleModel>();

	protected readonly angle = signal<'role' | 'person'>('role');

	protected readonly groupsByType = computed(() => buildRoleHistoryByType(this.roleModels()));
	protected readonly byPerson = computed(() => buildRoleHistoryByPerson(this.roleModels()));

	/** Eindeutiger Track-Key je Rolle (für `@for`). */
	protected readonly roleTrackKey = roleTrackKey;

	protected onAngleChange(value: unknown): void {
		this.angle.set(value as 'role' | 'person');
	}

	protected emitOpen(roleModel: RoleModel): void {
		this.openPerson.emit(roleModel);
	}
}
